





























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Enterprise } from '@/models/admin/enterprise';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { tenantService, enterpriseService } from '@/shared';

@Component({
  props: ['methodName'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class EnterpriseListPage extends Base {
  public pagedEnterprise: Enterprise[] = [];
  public paginations = new PaginationModel('name', true, 5);
  public loading: boolean = false;
  public deleteDialog: IDialogOption = {
    width: 400,
    title: 'Confirm?',
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteEnterprise();
    },
  };
  public enterpriseToDelete: Enterprise = new Enterprise();
  public headers: VHeaders[] = [];
  public actions: any[] = [];
  public tenants: any[] = [];
  public selectedTenantId: number = 0;

  public setHeaders() {
    this.headers = [
      {
        align: 'left',
        sortable: true,
        text: this.$parent.$tc('enterprise.headers', 1) as string,
        value: 'name',
      },
      {
        align: 'center',
        text: this.$parent.$tc('enterprise.headers', 2) as string,
        isNotDataProp: true,
        sortable: false,
      },
    ];
  }
  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-edit',
        title: this.$parent.$tc('enterprise.actions', 1) as string,
        color: 'primary',
        action: (model: Enterprise) => {
          this.addOrUpdateLink(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-trash-alt',
        title: this.$parent.$tc('enterprise.actions', 2) as string,
        color: 'error',
        visible: () => {
          return false;
        },
        action: (model: Enterprise) => {
          this.confirmDelete(model);
        },
      },
      {
        type: 'link',
        icon: 'fas fa-code-branch',
        title: 'Add Deparment',
        color: 'primary',
        visible: (model) => true,
        action: (model: Enterprise) => {
          return {
            name: 'admin.enterprises.addDeparment',
            params: {
              id: model.id
            },
          };
        },
      },
    ];
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addEnterprise') {
      this.$router.push({
        name: 'admin.enterprises.add',
        params: {
          tenantId: this.selectedTenantId.toString(),
        },
      });
    }

    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'enterprise');
    // Toolbar
    const buttons = [
      {
        id: '0',
        type: 'button',
        title: this.$parent.$t('enterprise.addEnterprise'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('enterprise.addEnterprise'),
        click: 'addEnterprise',
        icon: 'fas fa-plus-circle',
      },
    ];
    this.$emit('updateToolBar', buttons);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.selectedTenantId = Number(this.$route.params.tenantId);

    this.setHeaders();
    this.setActions();
    this.getTenants();
  }
  public async getTenants(): Promise<void> {
    try {
      this.loading = true;
      const tenants = await tenantService.getAllAsync();
      if (tenants.results && tenants.results.length > 0) {
        this.tenants = tenants.results;
        if (this.$route.params.tenantId) {
          this.selectedTenantId = Number(this.$route.params.tenantId);
        } else {
          this.selectedTenantId = Number(this.tenants[0].id);
        }
        this.getEnterprises();
      }
    } finally {
      this.loading = false;
    }
  }
  public async getEnterprises(): Promise<void> {
    try {
      this.loading = true;
      const enerprises = await enterpriseService.getAllAsync(
        this.selectedTenantId
      );
      this.pagedEnterprise = enerprises.results;
      this.paginations.totalItems = enerprises.total;
    } finally {
      this.loading = false;
    }
  }
  public updatePaging(paging: any) {
    this.paginations = paging;
  }

  public confirmDelete(item: Enterprise): void {
    this.deleteDialog.model = true;
    this.enterpriseToDelete = item;
  }
  public async deleteEnterprise(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await enterpriseService.deleteAsync(this.enterpriseToDelete.id);
      this.getEnterprises();
      this.showAlert(true, this.$parent.$t('enterprise.Delete'));
    } finally {
      this.deleteDialog.loading = false;
      this.deleteDialog.model = false;
    }
  }
  public addOrUpdateLink(model: any): void {
    if (model) {
      this.$router.push({
        name: 'admin.enterprises.edit',
        params: { id: model.id },
      });
    } else {
      this.$router.push({ name: 'admin.enterprises.add' });
    }
  }
}
